import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { logout } from "../../auth/authService";
import "./AdminLayout.css";

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  const activeLinkStyle = ({ isActive }) =>
    isActive ? "admin-link active" : "admin-link";

  return (
    <div className="admin-layout">
      {/* ================= SIDEBAR ================= */}
      <aside className="admin-sidebar">
        <h2 className="admin-logo">Admin Panel</h2>

        <nav className="admin-nav">
          <NavLink to="/admin" end className={activeLinkStyle}>
            Dashboard
          </NavLink>

          <NavLink to="/admin/users" className={activeLinkStyle}>
            Users
          </NavLink>

            <NavLink to="/admin/admin-payment-dashboard" className={activeLinkStyle}>
            Payment Dashboard
          </NavLink>

            <NavLink to="/admin/admin_speakers" className={activeLinkStyle}>
            Speaker Management
          </NavLink>

          <NavLink to="/admin/subscription_plans" className={activeLinkStyle}>
            Subscription Plans
          </NavLink>

           <NavLink to="/admin/admin_time_table" className={activeLinkStyle}>
            Time Table
          </NavLink>

            <NavLink to="/admin/admin_session_booking" className={activeLinkStyle}>
            Session Booking
          </NavLink>


          <NavLink to="/admin/admin-events" className={activeLinkStyle}>
            Events
          </NavLink>

          <NavLink to="/admin/email-campaign-page" className={activeLinkStyle}>
            Email campaign
          </NavLink>

           <NavLink to="/admin/admin-announcement" className={activeLinkStyle}>
            Announcement
          </NavLink>

          {/* Optional: direct links to widgets 
          <NavLink to="/admin/revenue-by-plan" className={activeLinkStyle}>
            Revenue by Plan
          </NavLink>

          <NavLink to="/admin/monthly-revenue" className={activeLinkStyle}>
            Monthly Revenue
          </NavLink>

          <NavLink to="/admin/user-growth" className={activeLinkStyle}>
            User Growth
          </NavLink>

          <NavLink to="/admin/free-to-paid" className={activeLinkStyle}>
            Free → Paid Conversion
          </NavLink>  */}

           <NavLink to="/admin/admin-support" className={activeLinkStyle}>
            Admin Support
          </NavLink>

          <NavLink to="/admin/admin-app-update" className={activeLinkStyle}>
            App updates
          </NavLink>

          <NavLink to="/admin/admin-user-review" className={activeLinkStyle}>
            Customer Reviews
          </NavLink>

          <NavLink to="/admin/admin-db-backup" className={activeLinkStyle}>
            Database backup
          </NavLink>

          <NavLink to="/admin/admin-manual-task" className={activeLinkStyle}>
            Manual Task
            </NavLink>
            
          <NavLink to="/admin/admin-account-handling" className={activeLinkStyle}>
            Account Handling
          </NavLink>

          <NavLink to="/admin/admin-faq" className={activeLinkStyle}>
            FAQ
          </NavLink>

          <NavLink to="/admin/content" className={activeLinkStyle}>
           Content
           </NavLink>
          
        </nav>
      

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </aside>

      {/* ================= MAIN CONTENT ================= */}
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
